// Golf 2 (0031) in de ouder-webapp: de checklist bij een herinnering (onder "Tekst" in het
// formulier, en de vinkjes op het afspraakblad) en vaste activiteiten met pauzes (blok in de
// afspraak-editor, balken bovenin de agenda, het pauzeblad). Sleutels in `a.checklist.*` en
// `a.activities.*` (app.nl.ts). Je-vorm, kort (docs/DESIGN.md §2).
export const appChecklistNl = {
    title: 'Checklist',
    hint: 'Wat moet er mee? De tablet toont het lijstje naast de oproep en je kind vinkt het af.',
    empty: 'Nog niets op de lijst. Kies hieronder of voeg zelf iets toe.',
    suggestions: 'Voorstellen',
    /** Chip "+ Zwembroek" onder de lijst. */
    suggestionAdd: '{label} toevoegen',
    addAll: 'Alles toevoegen',
    newLabel: 'Iets anders',
    newPlaceholder: 'Bijvoorbeeld: Zwembril',
    add: 'Toevoegen',
    labelRequired: 'Vul een woord in.',
    labelTooLong: 'Maximaal 40 tekens.',
    max: 'Hooguit 12 dingen per lijst.',
    itemPicto: 'Plaatje voor {label}',
    up: '{label} omhoog',
    down: '{label} omlaag',
    remove: '{label} weghalen',
    /** Voorbeeld in het formulier. */
    previewTitle: 'Naast de oproep',
    // Afspraakblad: vinkjes per kind op deze keer.
    sheetTitle: 'Mee in de tas',
    sheetProgress: '{done} van {total} ingepakt',
    sheetAllDone: 'Alles ingepakt',
    sheetNone: 'Nog niets afgevinkt',
    sheetItemDone: '{label}: ingepakt',
    sheetItemOpen: '{label}: nog niet',
    // Namen van de voorstellen (sleutel = pictogram-id of eigen sleutel).
    items: {
        'swim-trunks': 'Zwembroek',
        swimsuit: 'Badpak',
        towel: 'Handdoek',
        underwear: 'Onderbroek',
        socks: 'Sokken',
        shampoo: 'Shampoo',
        slippers: 'Slippers',
        'football-boots': 'Voetbalschoenen',
        'shin-guards': 'Scheenbeschermers',
        'water-bottle': 'Bidon',
        quran: 'Koran',
        backpack: 'Tas',
        headscarf: 'Hoofddoek',
        'prayer-cap': 'Takke',
        coat: 'Jas',
        shoes: 'Schoenen',
        lunch: 'Lunch',
        fruit: 'Fruit',
        homework: 'Huiswerk',
        reading: 'Leesboek',
        'music-lesson': 'Muziekboek',
        'get-dressed': 'Sportkleren',
    },
};
export const appActivitiesNl = {
    // Blok in de afspraak-editor (alleen bij een herhaling).
    section: 'Vaste activiteit',
    toggle: 'Dit is een vaste activiteit',
    toggleHint: 'Zoals school, moskeeles of voetbal: gaat elke week door, behalve in de vakanties en pauzes die je hieronder kiest.',
    needsRecurrence: 'Kies eerst een herhaling: een vaste activiteit komt elke week terug.',
    followSchool: 'Volgt de schoolvakanties',
    followSchoolHint: 'In de schoolvakanties van regio {region} gaat deze activiteit niet door.',
    followSchoolNoRegion: 'Kies je schoolvakantieregio via Instellingen hieronder. Deze regio geldt voor het hele gezin.',
    regions: { noord: 'Noord', midden: 'Midden', zuid: 'Zuid' },
    pauses: 'Pauzes',
    pausesHint: 'Periodes waarin deze activiteit stilligt. Een pauze kun je delen met andere activiteiten.',
    noPauses: 'Nog geen pauzes.',
    newPause: 'Nieuwe pauze',
    pauseName: 'Naam',
    pauseNamePlaceholder: 'Zomerstop',
    pauseFrom: 'Van',
    pauseTo: 'Tot en met',
    pauseAdd: 'Pauze toevoegen',
    pauseCancel: 'Annuleren',
    pauseNameRequired: 'Geef de pauze een naam.',
    pauseRangeInvalid: 'Kies een einddatum op of na de begindatum, binnen een jaar.',
    pausePresets: {
        zomerstop: 'Zomerstop',
        winterstop: 'Winterstop',
        zomervakantie: 'Zomervakantie',
    },
    /** "Ook bij: Moskeeles" onder een pauze die andere activiteiten ook hebben. */
    sharedWith: 'Ook bij: {names}',
    saved: 'Vaste activiteit opgeslagen',
    saveFailed: 'De afspraak is opgeslagen, maar de pauzes niet. Probeer het opnieuw.',
    // Balken bovenin de agenda en het blad van een balk.
    barLabel: '{title}, {range}',
    schoolHoliday: 'Schoolvakantie',
    pause: 'Pauze',
    stops: 'Ligt stil: {names}',
    stopsNone: 'Geen vaste activiteit ligt dan stil.',
    sheetSchoolHint: 'De schoolvakanties komen van de Rijksoverheid, voor jouw regio. Een vaste activiteit die ze volgt, gaat dan niet door.',
    sheetPauseHint: 'In deze periode gaan de activiteiten hieronder niet door: geen oproep, geen rit.',
    editPause: 'Pauze wijzigen',
    deletePause: 'Pauze weghalen',
    deletePauseConfirm: 'Weet je het zeker? De activiteiten gaan dan in deze periode gewoon door.',
    pauseDeleted: 'Pauze "{name}" weggehaald',
    pauseUpdated: 'Pauze "{name}" opgeslagen',
    /** Chip op het afspraakblad. */
    fixedChip: 'Vaste activiteit',
};
//# sourceMappingURL=golf2App.nl.js.map